module.exports = __webpack_public_path__ + "0d0d66baae88a9e37c4c7655dcb168c2.jpg";